import React, { useState, useEffect } from 'react';
import PlatformLogin from './PlatformLogin';
import PlatformDashboard from './PlatformDashboard';

export default function PlatformAdminPage() {
  const [token, setToken] = useState(() => localStorage.getItem('platform_admin_token'));
  const [admin, setAdmin] = useState(() => {
    try {
      const stored = localStorage.getItem('platform_admin');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const handleLogin = (newToken, adminData) => {
    setToken(newToken);
    setAdmin(adminData);
    localStorage.setItem('platform_admin_token', newToken);
    localStorage.setItem('platform_admin', JSON.stringify(adminData));
  };

  const handleLogout = () => {
    setToken(null);
    setAdmin(null);
    localStorage.removeItem('platform_admin_token');
    localStorage.removeItem('platform_admin');
  };

  if (!token || !admin) {
    return <PlatformLogin onLogin={handleLogin} />;
  }

  return <PlatformDashboard token={token} admin={admin} onLogout={handleLogout} />;
}
